/**
 * @module yeymaps/Map
 * @description
 * Custom Yeymaps Map class extending OpenLayers Map, providing a
 * foundation for custom behaviors, event handling, and view management.
 */

import OlMap, * as MapModule from './../node_modules/ol/Map.js';

// side-effect patch (DO NOT REMOVE)
import './render/canvas/TextBuilder.js';

/**
 * Yeymaps Map class extending the OpenLayers Map.
 *
 * @example
 * import Map from 'yeymaps/Map.js';
 * import View from 'yeymaps/View.js';
 *
 * const map = new Map({
 *   target: 'map',
 *   view: new View({
 *     center: [0, 0],
 *     zoom: 2,
 *   }),
 * });
 */
class Map extends OlMap {
  /**
   * @param {import('ol/Map').MapOptions} options - OpenLayers Map options.
   */
  constructor(options = {}) {
    super(options);
  }

  /**
   * Adds a layer safely, preventing duplicates.
   * @param {import('ol/layer/Layer').default} layer
   */
  addUniqueLayer(layer) {
    if (!this.getLayers().getArray().includes(layer)) {
      this.addLayer(layer);
    }
  }

  /**
   * Removes all layers except the base map (if any).
   */
  clearLayers(keepBase = true) {
    const layers = this.getLayers();
    if (!layers) return;

    const toRemove = layers.getArray().filter((l, idx) => !keepBase || idx !== 0);
    toRemove.forEach(l => layers.remove(l));
  }
}

// Copy all named exports as static methods
for (const key in MapModule) {
    if (key !== "default") {
        Map[key] = MapModule[key];
    }
}

export default Map;

// Re-export ALL named exports from OL
export * from './../node_modules/ol/Map.js';